import React from 'react';
import { Typography } from '@mui/material';

const SubHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <Typography
      color="#4A545D"
      fontSize="16px"
      fontWeight={500}
      lineHeight="24px"
      marginBottom="8px"
    >
      {children}
    </Typography>
  );
};

export default SubHeader;
